import React from 'react';
import clsx from 'clsx';

import { ModalBasicType } from '@/types/common';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from '../ModalComponent/ModalComponent';

interface OnboardingCommonModalProps extends ModalBasicType {
  icon: React.ReactNode | string;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  onClose: () => void;
  buttonText: string | React.ReactNode;
  iconBgColor?: string;
  titleClassName?: string;
}

const OnboardingCommonModal = ({
  show,
  title,
  description,
  onClose,
  icon,
  buttonText,
  iconBgColor,
  titleClassName = '',
}: OnboardingCommonModalProps) => {
  return (
    <ModalComponent show={show} onClose={onClose} outsideClickClose={false} width={420}>
      <div className="flex flex-col items-center gap-6">
        <IconContainer icon={icon} bgColor={iconBgColor} />
        <div>
          <h1 className={clsx('text-xl font-medium text-center mb-4', titleClassName)}>{title}</h1>
          <p className="text-base font-normal text-subdued text-center">{description}</p>
        </div>
        <ButtonComponent fullWidth onClick={onClose}>
          {buttonText}
        </ButtonComponent>
      </div>
    </ModalComponent>
  );
};

export default OnboardingCommonModal;
